import { CheckPlaneIcon } from "@images/svgIcons/status/checkPlaneIcon"
import { ErrorPlaneIcon } from "@images/svgIcons/status/errorPlaneIcon"
import { boxStaffPermissions } from "@modules/boxStaff/utils/boxStaffUtils"
import { word } from "@modules/core/utils/i18n"
import { useLanguage } from "@modules/language/hooks/useLanguage"
import { HUText } from "@modules/ui/components/huText"
import { HUDialog } from "@modules/ui/components/popup/huDialog"
import { useCallback, useImperativeHandle, useMemo, useState } from "react"
import { useTheme } from "styled-components"

export type BoxStaffPermissionsModalRef = {
  open: () => void
}

export function BoxStaffPermissionsModal({ ref }: { ref: React.Ref<BoxStaffPermissionsModalRef> }) {
  const [showModal, setShowModal] = useState(false)
  const theme = useTheme()
  const language = useLanguage()

  const onHide = useCallback(() => {
    setShowModal(false)
  }, [])

  useImperativeHandle(ref, () => ({
    open: () => {
      setShowModal(true)
    },
  }))

  const permissions = useMemo(() => {
    return boxStaffPermissions()
  }, [language])

  return (
    <HUDialog
      visible={showModal}
      header={word("box.staff.permissionsModal.header.modalTitle")}
      onHide={onHide}
      style={{ width: "850px" }}
    >
      <div className="flex flex-column w-full h-full bg-neutralColor-50 rounded-33 p-6">
        <div className="grid bg-black rounded-full w-full align-items-center py-2">
          <div className="col p-1"></div>
          <div className="col-3 p-0">
            <HUText fontStyle="LM" color={theme.mainWhite}>
              {word("box.staff.permissionsModal.header.feature")}
            </HUText>
          </div>
          <div className="flex col p-1 justify-content-center">
            <HUText fontStyle="LM" color={theme.mainWhite}>
              {word("box.staff.permissionsModal.header.owner")}
            </HUText>
          </div>
          <div className="flex col p-1 justify-content-center">
            <HUText fontStyle="LM" color={theme.mainWhite}>
              {word("box.staff.permissionsModal.header.coOwner")}
            </HUText>
          </div>
          <div className="flex col p-1 justify-content-center">
            <HUText fontStyle="LM" color={theme.mainWhite}>
              {word("box.staff.permissionsModal.header.headCoach")}
            </HUText>
          </div>
          <div className="flex col p-1 justify-content-center">
            <HUText fontStyle="LM" color={theme.mainWhite}>
              {word("box.staff.permissionsModal.header.coach")}
            </HUText>
          </div>
          <div className="flex col p-1 justify-content-center">
            <HUText fontStyle="LM" color={theme.mainWhite}>
              {word("box.staff.permissionsModal.header.financial")}
            </HUText>
          </div>
        </div>

        {permissions.map((permission) =>
          permission.features.map((feature) => (
            <div
              key={feature.name}
              className="grid  w-full align-items-center py-3 border-bottom-1 border-neutralColor-200"
            >
              <div className="col p-1">
                {permission.features.indexOf(feature) === 0 && (
                  <HUText fontStyle="BS" color={theme.mainWhite}>
                    {permission.category}
                  </HUText>
                )}
              </div>
              <div className="col-3 p-0">
                <HUText fontStyle="BM" color={theme.mainWhite}>
                  {feature.name}
                </HUText>
              </div>
              <div className="flex col p-1 align-items-center justify-content-center ">
                {feature.owner ? (
                  <CheckPlaneIcon color={theme.mainWhite} size={24} />
                ) : (
                  <ErrorPlaneIcon color={theme.mainWhite} size={24} />
                )}
              </div>
              <div className="flex col p-1 align-items-center justify-content-center">
                {feature.coOwner ? (
                  <CheckPlaneIcon color={theme.mainWhite} size={24} />
                ) : (
                  <ErrorPlaneIcon color={theme.mainWhite} size={24} />
                )}
              </div>
              <div className="flex col p-1 align-items-center justify-content-center">
                {feature.headCoach ? (
                  <CheckPlaneIcon color={theme.mainWhite} size={24} />
                ) : (
                  <ErrorPlaneIcon color={theme.mainWhite} size={24} />
                )}
              </div>
              <div className="flex col p-1 align-items-center justify-content-center">
                {feature.coach ? (
                  <CheckPlaneIcon color={theme.mainWhite} size={24} />
                ) : (
                  <ErrorPlaneIcon color={theme.mainWhite} size={24} />
                )}
              </div>
              <div className="flex col p-1 align-items-center justify-content-center">
                {feature.financial ? (
                  <CheckPlaneIcon color={theme.mainWhite} size={24} />
                ) : (
                  <ErrorPlaneIcon color={theme.mainWhite} size={24} />
                )}
              </div>
            </div>
          )),
        )}
      </div>
    </HUDialog>
  )
}
